const getKey = id => `sorting-${id}`;

export const encode = data => {
  return JSON.stringify(data);
};

export const decode = data => {
  if (!data) return undefined;
  return JSON.parse(data);
};

export const setSorting = (tableId, { orderBy, orderDirection }) => {
  return window.localStorage.setItem(
    getKey(tableId),
    encode({ orderBy, orderDirection }),
  );
};

export const getSorting = (tableId, defaultValue = null) => {
  return decode(window.localStorage.getItem(getKey(tableId))) || defaultValue;
};
